import { createReduxAsyncThunk } from 'shared/utils';
import { driversAPI } from 'entities/drivers';

import { DRIVERS_STATE } from '../../constants';

export const getDriverLocations = createReduxAsyncThunk(
  `${DRIVERS_STATE}/getDriverLocations`,
  async () => {
    const { data } = await driversAPI.getDriverLocations();
    return data;
  }
);
